import React, { useState, useEffect, useCallback, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { ProfileContext } from "../context/ProfileContext";
import cvApi from "../services/cvApi";
import {
  IoArrowBack,
  IoAdd,
  IoCreateOutline,
  IoTrashOutline,
  IoChevronDown,
  IoChevronUp,
  IoClose,
  IoCheckmarkCircle,
  IoCloseCircle,
  IoSchoolOutline,
  IoBriefcaseOutline,
  IoRibbonOutline,
} from "react-icons/io5";
import { BiSolidUser } from "react-icons/bi";

import { currentCountry } from "../utils/country";

// Translations
const translations = {
  MN: {
    cv: "CV / Анкет",
    back: "Буцах",
    save: "Хадгалах",
    cancel: "Цуцлах",
    loading: "Ачаалж байна...",
    summary: "Товч танилцуулга",
    summaryPlaceholder: "Өөрийнхөө талаар товч бичнэ үү...",
    noSummary: "Танилцуулга нэмээгүй. Засахын тулд дарна уу.",
    education: "Боловсрол",
    noEducation: "Боловсрол нэмээгүй байна",
    addEducation: "Боловсрол нэмэх",
    editEducation: "Боловсрол засах",
    institution: "Сургууль",
    degree: "Зэрэг",
    fieldOfStudy: "Мэргэжил",
    experience: "Ажлын туршлага",
    noExperience: "Туршлага нэмээгүй байна",
    addExperience: "Туршлага нэмэх",
    editExperience: "Туршлага засах",
    jobTitle: "Албан тушаал",
    company: "Компани",
    industry: "Салбар",
    skills: "Ур чадвар",
    noSkills: "Ур чадвар нэмээгүй байна",
    addSkill: "Ур чадвар нэмэх",
    editSkill: "Ур чадвар засах",
    skillName: "Ур чадварын нэр",
    category: "Ангилал",
    proficiency: "Түвшин",
    startDate: "Эхэлсэн огноо",
    endDate: "Дууссан огноо",
    currentlyHere: "Одоо энд",
    description: "Тайлбар",
    yearsExp: "Жилийн туршлага",
    confirmDelete: "Устгахдаа итгэлтэй байна уу?",
    saveSuccess: "Амжилттай хадгалагдлаа",
    saveError: "Хадгалахад алдаа гарлаа",
    technical: "Техникийн",
    soft: "Зөөлөн",
    language: "Хэл",
    tool: "Хэрэгсэл",
    beginner: "Анхан шат",
    intermediate: "Дунд",
    advanced: "Ахисан",
    expert: "Мэргэжилтэн",
    completeness: "Бүрэн байдал",
  },
  UZ: {
    cv: "CV / Rezume",
    back: "Orqaga",
    save: "Saqlash",
    cancel: "Bekor qilish",
    loading: "Yuklanmoqda...",
    summary: "Qisqacha ma'lumot",
    summaryPlaceholder: "O'zingiz haqingizda qisqacha yozing...",
    noSummary: "Ma'lumot qo'shilmagan. Tahrirlash uchun bosing.",
    education: "Ta'lim",
    noEducation: "Ta'lim qo'shilmagan",
    addEducation: "Ta'lim qo'shish",
    editEducation: "Ta'limni tahrirlash",
    institution: "O'quv muassasasi",
    degree: "Daraja",
    fieldOfStudy: "Yo'nalish",
    experience: "Ish tajribasi",
    noExperience: "Tajriba qo'shilmagan",
    addExperience: "Tajriba qo'shish",
    editExperience: "Tajribani tahrirlash",
    jobTitle: "Lavozim",
    company: "Kompaniya",
    industry: "Soha",
    skills: "Ko'nikmalar",
    noSkills: "Ko'nikma qo'shilmagan",
    addSkill: "Ko'nikma qo'shish",
    editSkill: "Ko'nikmani tahrirlash",
    skillName: "Ko'nikma nomi",
    category: "Turkum",
    proficiency: "Daraja",
    startDate: "Boshlanish sanasi",
    endDate: "Tugash sanasi",
    currentlyHere: "Hozirda shu yerda",
    description: "Tavsif",
    yearsExp: "Tajriba yillari",
    confirmDelete: "O'chirishni tasdiqlaysizmi?",
    saveSuccess: "Muvaffaqiyatli saqlandi",
    saveError: "Saqlashda xatolik",
    technical: "Texnik",
    soft: "Yumshoq",
    language: "Til",
    tool: "Vosita",
    beginner: "Boshlang'ich",
    intermediate: "O'rta",
    advanced: "Yuqori",
    expert: "Ekspert",
    completeness: "To'liqlik",
  },
  KZ: {
    cv: "CV / Резюме",
    back: "Назад",
    save: "Сохранить",
    cancel: "Отмена",
    loading: "Загрузка...",
    summary: "Краткое описание",
    summaryPlaceholder: "Напишите кратко о себе...",
    noSummary: "Описание не добавлено. Нажмите для редактирования.",
    education: "Образование",
    noEducation: "Образование не добавлено",
    addEducation: "Добавить образование",
    editEducation: "Редактировать образование",
    institution: "Учебное заведение",
    degree: "Степень",
    fieldOfStudy: "Направление",
    experience: "Опыт работы",
    noExperience: "Опыт не добавлен",
    addExperience: "Добавить опыт",
    editExperience: "Редактировать опыт",
    jobTitle: "Должность",
    company: "Компания",
    industry: "Отрасль",
    skills: "Навыки",
    noSkills: "Навыки не добавлены",
    addSkill: "Добавить навык",
    editSkill: "Редактировать навык",
    skillName: "Название навыка",
    category: "Категория",
    proficiency: "Уровень",
    startDate: "Дата начала",
    endDate: "Дата окончания",
    currentlyHere: "В настоящее время",
    description: "Описание",
    yearsExp: "Лет опыта",
    confirmDelete: "Вы уверены, что хотите удалить?",
    saveSuccess: "Успешно сохранено",
    saveError: "Ошибка при сохранении",
    technical: "Технические",
    soft: "Мягкие",
    language: "Язык",
    tool: "Инструмент",
    beginner: "Начинающий",
    intermediate: "Средний",
    advanced: "Продвинутый",
    expert: "Эксперт",
    completeness: "Полнота",
  },
};

const t = translations[currentCountry];

// Toast Component
const Toast = ({ message, type, onClose }) => {
  useEffect(() => {
    const timer = setTimeout(onClose, 3000);
    return () => clearTimeout(timer);
  }, [onClose]);

  return (
    <div className="fixed bottom-20 left-1/2 transform -translate-x-1/2 z-50 animate-slide-up">
      <div
        className={`flex items-center gap-3 px-5 py-3 rounded-xl shadow-lg ${
          type === "success"
            ? "bg-green-50 border border-green-200"
            : "bg-red-50 border border-red-200"
        }`}
      >
        {type === "success" ? (
          <IoCheckmarkCircle className="text-green-500 text-xl flex-shrink-0" />
        ) : (
          <IoCloseCircle className="text-red-500 text-xl flex-shrink-0" />
        )}
        <span
          className={`text-sm font-medium ${
            type === "success" ? "text-green-700" : "text-red-700"
          }`}
        >
          {message}
        </span>
      </div>
    </div>
  );
};

// Modal Component
const Modal = ({ isOpen, onClose, title, children }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
      <div className="absolute inset-0 bg-black/50" onClick={onClose} />
      <div className="relative bg-white rounded-xl w-full max-w-md max-h-[90vh] overflow-y-auto">
        <div className="sticky top-0 bg-white px-4 py-3 border-b flex justify-between items-center">
          <h3 className="font-semibold text-gray-800">{title}</h3>
          <button onClick={onClose} className="p-1 hover:bg-gray-100 rounded-full">
            <IoClose className="text-xl text-gray-500" />
          </button>
        </div>
        <div className="p-4">{children}</div>
      </div>
    </div>
  );
};

// Section Header
const SectionHeader = ({ icon: Icon, title, onAdd, isExpanded, onToggle }) => (
  <div
    className="flex items-center justify-between py-3 cursor-pointer"
    onClick={onToggle}
  >
    <div className="flex items-center gap-2">
      <Icon className="text-gray-700 text-lg" />
      <span className="font-medium text-gray-800">{title}</span>
    </div>
    <div className="flex items-center gap-2">
      <button
        onClick={(e) => {
          e.stopPropagation();
          onAdd();
        }}
        className="p-1.5 rounded-full bg-black text-white hover:bg-gray-800 transition"
      >
        <IoAdd className="text-sm" />
      </button>
      {isExpanded ? (
        <IoChevronUp className="text-gray-500" />
      ) : (
        <IoChevronDown className="text-gray-500" />
      )}
    </div>
  </div>
);

// Forms
const EducationForm = ({ education, onSave, onCancel, isLoading }) => {
  const [form, setForm] = useState({
    institutionName: education?.institutionName || "",
    degree: education?.degree || "",
    fieldOfStudy: education?.fieldOfStudy || "",
    startDate: education?.startDate?.substring(0, 10) || "",
    endDate: education?.endDate?.substring(0, 10) || "",
    isCurrent: education?.isCurrent || false,
  });

  return (
    <form
      onSubmit={(e) => {
        e.preventDefault();
        onSave(form);
      }}
      className="space-y-4"
    >
      <div>
        <label className="block text-sm text-gray-600 mb-1">{t.institution}*</label>
        <input
          type="text"
          value={form.institutionName}
          onChange={(e) => setForm({ ...form, institutionName: e.target.value })}
          className="w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-black"
          required
        />
      </div>
      <div>
        <label className="block text-sm text-gray-600 mb-1">{t.degree}</label>
        <input
          type="text"
          value={form.degree}
          onChange={(e) => setForm({ ...form, degree: e.target.value })}
          className="w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-black"
        />
      </div>
      <div>
        <label className="block text-sm text-gray-600 mb-1">{t.fieldOfStudy}</label>
        <input
          type="text"
          value={form.fieldOfStudy}
          onChange={(e) => setForm({ ...form, fieldOfStudy: e.target.value })}
          className="w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-black"
        />
      </div>
      <div className="grid grid-cols-2 gap-3">
        <div>
          <label className="block text-sm text-gray-600 mb-1">{t.startDate}</label>
          <input
            type="date"
            value={form.startDate}
            onChange={(e) => setForm({ ...form, startDate: e.target.value })}
            className="w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-black"
          />
        </div>
        <div>
          <label className="block text-sm text-gray-600 mb-1">{t.endDate}</label>
          <input
            type="date"
            value={form.endDate}
            onChange={(e) => setForm({ ...form, endDate: e.target.value })}
            disabled={form.isCurrent}
            className="w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-black disabled:bg-gray-100"
          />
        </div>
      </div>
      <label className="flex items-center gap-2 cursor-pointer">
        <input
          type="checkbox"
          checked={form.isCurrent}
          onChange={(e) => setForm({ ...form, isCurrent: e.target.checked })}
        />
        <span className="text-sm text-gray-600">{t.currentlyHere}</span>
      </label>
      <div className="flex gap-3 pt-2">
        <button
          type="button"
          onClick={onCancel}
          className="flex-1 py-2 border rounded-lg text-gray-600 hover:bg-gray-50"
        >
          {t.cancel}
        </button>
        <button
          type="submit"
          disabled={isLoading}
          className="flex-1 py-2 bg-black text-white rounded-lg hover:bg-gray-800 disabled:opacity-50"
        >
          {isLoading ? "..." : t.save}
        </button>
      </div>
    </form>
  );
};

const ExperienceForm = ({ experience, onSave, onCancel, isLoading }) => {
  const [form, setForm] = useState({
    companyName: experience?.companyName || "",
    jobTitle: experience?.jobTitle || "",
    industry: experience?.industry || "",
    startDate: experience?.startDate?.substring(0, 10) || "",
    endDate: experience?.endDate?.substring(0, 10) || "",
    isCurrent: experience?.isCurrent || false,
    description: experience?.description || "",
  });

  return (
    <form
      onSubmit={(e) => {
        e.preventDefault();
        onSave(form);
      }}
      className="space-y-4"
    >
      <div>
        <label className="block text-sm text-gray-600 mb-1">{t.jobTitle}*</label>
        <input
          type="text"
          value={form.jobTitle}
          onChange={(e) => setForm({ ...form, jobTitle: e.target.value })}
          className="w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-black"
          required
        />
      </div>
      <div>
        <label className="block text-sm text-gray-600 mb-1">{t.company}*</label>
        <input
          type="text"
          value={form.companyName}
          onChange={(e) => setForm({ ...form, companyName: e.target.value })}
          className="w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-black"
          required
        />
      </div>
      <div>
        <label className="block text-sm text-gray-600 mb-1">{t.industry}</label>
        <input
          type="text"
          value={form.industry}
          onChange={(e) => setForm({ ...form, industry: e.target.value })}
          className="w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-black"
        />
      </div>
      <div className="grid grid-cols-2 gap-3">
        <div>
          <label className="block text-sm text-gray-600 mb-1">{t.startDate}</label>
          <input
            type="date"
            value={form.startDate}
            onChange={(e) => setForm({ ...form, startDate: e.target.value })}
            className="w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-black"
          />
        </div>
        <div>
          <label className="block text-sm text-gray-600 mb-1">{t.endDate}</label>
          <input
            type="date"
            value={form.endDate}
            onChange={(e) => setForm({ ...form, endDate: e.target.value })}
            disabled={form.isCurrent}
            className="w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-black disabled:bg-gray-100"
          />
        </div>
      </div>
      <label className="flex items-center gap-2 cursor-pointer">
        <input
          type="checkbox"
          checked={form.isCurrent}
          onChange={(e) => setForm({ ...form, isCurrent: e.target.checked })}
        />
        <span className="text-sm text-gray-600">{t.currentlyHere}</span>
      </label>
      <div>
        <label className="block text-sm text-gray-600 mb-1">{t.description}</label>
        <textarea
          value={form.description}
          onChange={(e) => setForm({ ...form, description: e.target.value })}
          className="w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-black min-h-[80px]"
        />
      </div>
      <div className="flex gap-3 pt-2">
        <button
          type="button"
          onClick={onCancel}
          className="flex-1 py-2 border rounded-lg text-gray-600 hover:bg-gray-50"
        >
          {t.cancel}
        </button>
        <button
          type="submit"
          disabled={isLoading}
          className="flex-1 py-2 bg-black text-white rounded-lg hover:bg-gray-800 disabled:opacity-50"
        >
          {isLoading ? "..." : t.save}
        </button>
      </div>
    </form>
  );
};

const SkillForm = ({ skill, onSave, onCancel, isLoading }) => {
  const [form, setForm] = useState({
    skillName: skill?.skillName || "",
    category: skill?.category || "TECHNICAL",
    proficiencyLevel: skill?.proficiencyLevel || "INTERMEDIATE",
    yearsOfExperience: skill?.yearsOfExperience || 0,
  });

  const categories = [
    { value: "TECHNICAL", label: t.technical },
    { value: "SOFT", label: t.soft },
    { value: "LANGUAGE", label: t.language },
    { value: "TOOL", label: t.tool },
  ];

  const levels = [
    { value: "BEGINNER", label: t.beginner },
    { value: "INTERMEDIATE", label: t.intermediate },
    { value: "ADVANCED", label: t.advanced },
    { value: "EXPERT", label: t.expert },
  ];

  return (
    <form
      onSubmit={(e) => {
        e.preventDefault();
        onSave(form);
      }}
      className="space-y-4"
    >
      <div>
        <label className="block text-sm text-gray-600 mb-1">{t.skillName}*</label>
        <input
          type="text"
          value={form.skillName}
          onChange={(e) => setForm({ ...form, skillName: e.target.value })}
          className="w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-black"
          required
        />
      </div>
      <div>
        <label className="block text-sm text-gray-600 mb-1">{t.category}</label>
        <select
          value={form.category}
          onChange={(e) => setForm({ ...form, category: e.target.value })}
          className="w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-black"
        >
          {categories.map((c) => (
            <option key={c.value} value={c.value}>
              {c.label}
            </option>
          ))}
        </select>
      </div>
      <div>
        <label className="block text-sm text-gray-600 mb-1">{t.proficiency}</label>
        <select
          value={form.proficiencyLevel}
          onChange={(e) => setForm({ ...form, proficiencyLevel: e.target.value })}
          className="w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-black"
        >
          {levels.map((l) => (
            <option key={l.value} value={l.value}>
              {l.label}
            </option>
          ))}
        </select>
      </div>
      <div>
        <label className="block text-sm text-gray-600 mb-1">{t.yearsExp}</label>
        <input
          type="number"
          min="0"
          max="50"
          value={form.yearsOfExperience}
          onChange={(e) =>
            setForm({ ...form, yearsOfExperience: parseInt(e.target.value) || 0 })
          }
          className="w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-black"
        />
      </div>
      <div className="flex gap-3 pt-2">
        <button
          type="button"
          onClick={onCancel}
          className="flex-1 py-2 border rounded-lg text-gray-600 hover:bg-gray-50"
        >
          {t.cancel}
        </button>
        <button
          type="submit"
          disabled={isLoading}
          className="flex-1 py-2 bg-black text-white rounded-lg hover:bg-gray-800 disabled:opacity-50"
        >
          {isLoading ? "..." : t.save}
        </button>
      </div>
    </form>
  );
};

// Main CV Component
export default function CV() {
  const navigate = useNavigate();
  const { profile } = useContext(ProfileContext);

  const [cv, setCv] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [isSaving, setIsSaving] = useState(false);
  const [toast, setToast] = useState(null);

  const [expandedSections, setExpandedSections] = useState({
    education: true,
    experience: true,
    skills: true,
  });

  const [modal, setModal] = useState({
    type: null,
    mode: null,
    data: null,
  });

  const [isEditingSummary, setIsEditingSummary] = useState(false);
  const [summaryText, setSummaryText] = useState("");

  const userPhone = cvApi.getPhoneFromToken();

  // Fetch CV
  const fetchCv = useCallback(async () => {
    if (!userPhone) {
      setIsLoading(false);
      return;
    }

    setIsLoading(true);
    try {
      const response = await cvApi.findOrCreateCv(userPhone);
      if (response.success && response.data) {
        setCv(response.data);
        setSummaryText(response.data.summary || "");
      }
    } catch (err) {
      console.error("Error fetching CV:", err);
    } finally {
      setIsLoading(false);
    }
  }, [userPhone]);

  useEffect(() => {
    fetchCv();
  }, [fetchCv]);

  const showToast = (message, type) => {
    setToast({ message, type });
  };

  const toggleSection = (section) => {
    setExpandedSections((prev) => ({
      ...prev,
      [section]: !prev[section],
    }));
  };

  const openModal = (type, mode, data = null) => {
    setModal({ type, mode, data });
  };

  const closeModal = () => {
    setModal({ type: null, mode: null, data: null });
  };

  // Save summary
  const handleSaveSummary = async () => {
    if (!cv?.id) return;
    setIsSaving(true);
    try {
      await cvApi.updateCv(cv.id, { summary: summaryText });
      setCv((prev) => ({ ...prev, summary: summaryText }));
      setIsEditingSummary(false);
      showToast(t.saveSuccess, "success");
    } catch (err) {
      showToast(t.saveError, "error");
    } finally {
      setIsSaving(false);
    }
  };

  // Education CRUD
  const handleSaveEducation = async (data) => {
    if (!cv?.id) return;
    setIsSaving(true);
    try {
      if (modal.mode === "edit" && modal.data?.id) {
        await cvApi.updateEducation(cv.id, modal.data.id, data);
      } else {
        await cvApi.addEducation(cv.id, data);
      }
      await fetchCv();
      closeModal();
      showToast(t.saveSuccess, "success");
    } catch (err) {
      showToast(t.saveError, "error");
    } finally {
      setIsSaving(false);
    }
  };

  const handleDeleteEducation = async (educationId) => {
    if (!cv?.id || !window.confirm(t.confirmDelete)) return;
    setIsSaving(true);
    try {
      await cvApi.deleteEducation(cv.id, educationId);
      await fetchCv();
      showToast(t.saveSuccess, "success");
    } catch (err) {
      showToast(t.saveError, "error");
    } finally {
      setIsSaving(false);
    }
  };

  // Experience CRUD
  const handleSaveExperience = async (data) => {
    if (!cv?.id) return;
    setIsSaving(true);
    try {
      if (modal.mode === "edit" && modal.data?.id) {
        await cvApi.updateExperience(cv.id, modal.data.id, data);
      } else {
        await cvApi.addExperience(cv.id, data);
      }
      await fetchCv();
      closeModal();
      showToast(t.saveSuccess, "success");
    } catch (err) {
      showToast(t.saveError, "error");
    } finally {
      setIsSaving(false);
    }
  };

  const handleDeleteExperience = async (experienceId) => {
    if (!cv?.id || !window.confirm(t.confirmDelete)) return;
    setIsSaving(true);
    try {
      await cvApi.deleteExperience(cv.id, experienceId);
      await fetchCv();
      showToast(t.saveSuccess, "success");
    } catch (err) {
      showToast(t.saveError, "error");
    } finally {
      setIsSaving(false);
    }
  };

  // Skill CRUD
  const handleSaveSkill = async (data) => {
    if (!cv?.id) return;
    setIsSaving(true);
    try {
      if (modal.mode === "edit" && modal.data?.id) {
        await cvApi.updateSkill(cv.id, modal.data.id, data);
      } else {
        await cvApi.addSkill(cv.id, data);
      }
      await fetchCv();
      closeModal();
      showToast(t.saveSuccess, "success");
    } catch (err) {
      showToast(t.saveError, "error");
    } finally {
      setIsSaving(false);
    }
  };

  const handleDeleteSkill = async (skillId) => {
    if (!cv?.id || !window.confirm(t.confirmDelete)) return;
    setIsSaving(true);
    try {
      await cvApi.deleteSkill(cv.id, skillId);
      await fetchCv();
      showToast(t.saveSuccess, "success");
    } catch (err) {
      showToast(t.saveError, "error");
    } finally {
      setIsSaving(false);
    }
  };

  if (isLoading) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="animate-spin border-4 border-t-4 rounded-full border-gray-300 border-t-black w-8 h-8"></div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50">
      {toast && (
        <Toast message={toast.message} type={toast.type} onClose={() => setToast(null)} />
      )}

      {/* Header */}
      <div className="bg-black text-white p-4 flex items-center gap-4">
        <button
          onClick={() => navigate(-1)}
          className="p-2 hover:bg-white hover:bg-opacity-10 rounded-full transition"
        >
          <IoArrowBack className="text-xl" />
        </button>
        <h1 className="text-xl font-bold">{t.cv}</h1>
      </div>

      <div className="max-w-2xl mx-auto p-4 space-y-4">
        {/* Profile Summary Card */}
        <div className="bg-white rounded-xl shadow-sm overflow-hidden">
          <div className="p-4 border-b">
            <div className="flex items-center gap-3">
              <div className="w-12 h-12 rounded-full bg-gray-100 flex items-center justify-center overflow-hidden">
                {profile?.photoUrl ? (
                  <img
                    src={profile.photoUrl}
                    alt="Profile"
                    className="w-full h-full object-cover"
                  />
                ) : (
                  <BiSolidUser className="text-2xl text-gray-400" />
                )}
              </div>
              <div>
                <p className="font-semibold text-gray-800">
                  {cv?.candidate?.firstName || profile?.name || "User"}
                </p>
                <p className="text-sm text-gray-500">{userPhone}</p>
              </div>
            </div>
          </div>

          {/* Summary */}
          <div className="p-4">
            <div className="flex items-center justify-between mb-2">
              <span className="text-sm font-medium text-gray-700">{t.summary}</span>
              <button
                onClick={() => setIsEditingSummary(!isEditingSummary)}
                className="text-gray-500 hover:text-gray-700"
              >
                <IoCreateOutline className="text-lg" />
              </button>
            </div>

            {isEditingSummary ? (
              <div>
                <textarea
                  value={summaryText}
                  onChange={(e) => setSummaryText(e.target.value)}
                  className="w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-black min-h-[100px] text-sm"
                  placeholder={t.summaryPlaceholder}
                />
                <div className="flex gap-2 mt-2">
                  <button
                    onClick={() => {
                      setSummaryText(cv?.summary || "");
                      setIsEditingSummary(false);
                    }}
                    className="px-3 py-1 text-sm text-gray-500 hover:text-gray-700"
                  >
                    {t.cancel}
                  </button>
                  <button
                    onClick={handleSaveSummary}
                    disabled={isSaving}
                    className="px-3 py-1 text-sm bg-black text-white rounded-lg hover:bg-gray-800 disabled:opacity-50"
                  >
                    {isSaving ? "..." : t.save}
                  </button>
                </div>
              </div>
            ) : (
              <p className="text-sm text-gray-500">{cv?.summary || t.noSummary}</p>
            )}
          </div>

          {/* Completeness */}
          {cv?.completenessPercentage !== undefined && (
            <div className="px-4 pb-4">
              <div className="flex items-center justify-between mb-1">
                <span className="text-xs text-gray-500">{t.completeness}</span>
                <span className="text-xs font-medium text-gray-700">
                  {cv.completenessPercentage}%
                </span>
              </div>
              <div className="h-2 bg-gray-200 rounded-full overflow-hidden">
                <div
                  className="h-full bg-black rounded-full transition-all"
                  style={{ width: `${cv.completenessPercentage}%` }}
                />
              </div>
            </div>
          )}
        </div>

        {/* Education Section */}
        <div className="bg-white rounded-xl shadow-sm overflow-hidden">
          <div className="px-4">
            <SectionHeader
              icon={IoSchoolOutline}
              title={t.education}
              onAdd={() => openModal("education", "add")}
              isExpanded={expandedSections.education}
              onToggle={() => toggleSection("education")}
            />
          </div>

          {expandedSections.education && (
            <div className="px-4 pb-4">
              {cv?.educations?.length > 0 ? (
                cv.educations.map((edu) => (
                  <div key={edu.id} className="p-3 bg-gray-50 rounded-lg mb-2">
                    <div className="flex justify-between items-start">
                      <div className="flex-1">
                        <p className="font-medium text-gray-800">{edu.institutionName}</p>
                        <p className="text-sm text-gray-500">
                          {edu.degree}
                          {edu.fieldOfStudy && ` - ${edu.fieldOfStudy}`}
                        </p>
                        <p className="text-xs text-gray-400 mt-1">
                          {edu.startDate?.substring(0, 7)} -{" "}
                          {edu.isCurrent ? "Present" : edu.endDate?.substring(0, 7)}
                        </p>
                      </div>
                      <div className="flex gap-1">
                        <button
                          onClick={() => openModal("education", "edit", edu)}
                          className="p-1.5 text-gray-500 hover:text-gray-700"
                        >
                          <IoCreateOutline size={16} />
                        </button>
                        <button
                          onClick={() => handleDeleteEducation(edu.id)}
                          className="p-1.5 text-gray-500 hover:text-red-500"
                        >
                          <IoTrashOutline size={16} />
                        </button>
                      </div>
                    </div>
                  </div>
                ))
              ) : (
                <p className="text-center text-gray-400 text-sm py-4">{t.noEducation}</p>
              )}
            </div>
          )}
        </div>

        {/* Experience Section */}
        <div className="bg-white rounded-xl shadow-sm overflow-hidden">
          <div className="px-4">
            <SectionHeader
              icon={IoBriefcaseOutline}
              title={t.experience}
              onAdd={() => openModal("experience", "add")}
              isExpanded={expandedSections.experience}
              onToggle={() => toggleSection("experience")}
            />
          </div>

          {expandedSections.experience && (
            <div className="px-4 pb-4">
              {cv?.experiences?.length > 0 ? (
                cv.experiences.map((exp) => (
                  <div key={exp.id} className="p-3 bg-gray-50 rounded-lg mb-2">
                    <div className="flex justify-between items-start">
                      <div className="flex-1">
                        <p className="font-medium text-gray-800">{exp.jobTitle}</p>
                        <p className="text-sm text-gray-500">{exp.companyName}</p>
                        <p className="text-xs text-gray-400 mt-1">
                          {exp.startDate?.substring(0, 7)} -{" "}
                          {exp.isCurrent ? "Present" : exp.endDate?.substring(0, 7)}
                        </p>
                        {exp.description && (
                          <p className="text-xs text-gray-500 mt-2 line-clamp-2">
                            {exp.description}
                          </p>
                        )}
                      </div>
                      <div className="flex gap-1">
                        <button
                          onClick={() => openModal("experience", "edit", exp)}
                          className="p-1.5 text-gray-500 hover:text-gray-700"
                        >
                          <IoCreateOutline size={16} />
                        </button>
                        <button
                          onClick={() => handleDeleteExperience(exp.id)}
                          className="p-1.5 text-gray-500 hover:text-red-500"
                        >
                          <IoTrashOutline size={16} />
                        </button>
                      </div>
                    </div>
                  </div>
                ))
              ) : (
                <p className="text-center text-gray-400 text-sm py-4">{t.noExperience}</p>
              )}
            </div>
          )}
        </div>

        {/* Skills Section */}
        <div className="bg-white rounded-xl shadow-sm overflow-hidden">
          <div className="px-4">
            <SectionHeader
              icon={IoRibbonOutline}
              title={t.skills}
              onAdd={() => openModal("skill", "add")}
              isExpanded={expandedSections.skills}
              onToggle={() => toggleSection("skills")}
            />
          </div>

          {expandedSections.skills && (
            <div className="px-4 pb-4">
              {cv?.skills?.length > 0 ? (
                <div className="flex flex-wrap gap-2">
                  {cv.skills.map((skill) => (
                    <div
                      key={skill.id}
                      className="inline-flex items-center gap-1 px-3 py-1.5 bg-gray-100 rounded-full"
                    >
                      <span className="text-sm text-gray-700">{skill.skillName}</span>
                      <span className="text-xs px-1.5 py-0.5 bg-gray-200 rounded-full text-gray-500">
                        {skill.proficiencyLevel?.toLowerCase()}
                      </span>
                      <button
                        onClick={() => openModal("skill", "edit", skill)}
                        className="p-0.5 text-gray-400 hover:text-gray-600"
                      >
                        <IoCreateOutline size={12} />
                      </button>
                      <button
                        onClick={() => handleDeleteSkill(skill.id)}
                        className="p-0.5 text-gray-400 hover:text-red-500"
                      >
                        <IoTrashOutline size={12} />
                      </button>
                    </div>
                  ))}
                </div>
              ) : (
                <p className="text-center text-gray-400 text-sm py-4">{t.noSkills}</p>
              )}
            </div>
          )}
        </div>
      </div>

      {/* Modals */}
      <Modal
        isOpen={modal.type === "education"}
        onClose={closeModal}
        title={modal.mode === "edit" ? t.editEducation : t.addEducation}
      >
        <EducationForm
          education={modal.data}
          onSave={handleSaveEducation}
          onCancel={closeModal}
          isLoading={isSaving}
        />
      </Modal>

      <Modal
        isOpen={modal.type === "experience"}
        onClose={closeModal}
        title={modal.mode === "edit" ? t.editExperience : t.addExperience}
      >
        <ExperienceForm
          experience={modal.data}
          onSave={handleSaveExperience}
          onCancel={closeModal}
          isLoading={isSaving}
        />
      </Modal>

      <Modal
        isOpen={modal.type === "skill"}
        onClose={closeModal}
        title={modal.mode === "edit" ? t.editSkill : t.addSkill}
      >
        <SkillForm
          skill={modal.data}
          onSave={handleSaveSkill}
          onCancel={closeModal}
          isLoading={isSaving}
        />
      </Modal>

      {/* Animation styles */}
      <style>{`
        @keyframes slide-up {
          from {
            opacity: 0;
            transform: translate(-50%, 20px);
          }
          to {
            opacity: 1;
            transform: translate(-50%, 0);
          }
        }
        .animate-slide-up {
          animation: slide-up 0.3s ease-out;
        }
      `}</style>
    </div>
  );
}
